import Vue from 'vue'
import pluralize from 'pluralize'

Vue.filter('pluralize', (val, num) => {
  return pluralize(val, num)
})
